import * as translation from "./en-GB.json";

export const translationEnGB = translation.default;
